import { FormEvent } from "react"
import classNames from "classnames"

import { useLazyGetStatesQuery, useLazyGetZipCodesQuery } from "store/api/dictionaryApi"
import { UITypes } from "types"
import styles from "assets/scss/index.module.scss"

import { InputNew } from "components/form/InputNew"
import { SelectDynamic } from "components/form/SelectDynamic"

const US_COUNTRY_ID = 1

interface Props {
  values: UITypes.User
  error: { field: string; message: string }
  onInputChange: (event: FormEvent<HTMLInputElement>) => void
  onSelectChange: (name: string, values: UITypes.Option[]) => void
}

export const ReferralAgentFields = ({ values, error, onInputChange, onSelectChange }: Props) => (
  <>
    <div className={styles.fieldGroupTop}>
      <SelectDynamic
        label="Zip code"
        placeholder="Enter zip code"
        name="zip"
        valueName="id"
        labelName="code"
        searchFieldName="code"
        values={values.zip || []}
        useLazyQuery={useLazyGetZipCodesQuery}
        queryParams={{ country_id: US_COUNTRY_ID }}
        onChange={data => onSelectChange("zip", data)}
        errorMessage={error.field === "zip" ? error.message : ""}
      />
    </div>
    <div className={classNames(styles.fieldRowSplit, styles.fieldGroupTop)}>
      <InputNew
        label="Business name (Optional)"
        placeholder="Enter brokerage"
        name="brokerageName"
        value={values.brokerageName}
        onChange={onInputChange}
        errorMessage={error.field === "brokerageName" ? error.message : ""}
      />
      <InputNew
        label="License number (Optional)"
        placeholder="Enter license number"
        name="licenseNumber"
        value={values.licenseNumber}
        onChange={onInputChange}
        errorMessage={error.field === "licenseNumber" ? error.message : ""}
      />
    </div>
    <div className={styles.fieldRowSplit}>
      <SelectDynamic
        label="State (Optional)"
        placeholder="Select state"
        name="state"
        valueName="id"
        labelName="name"
        values={values.state || []}
        useLazyQuery={useLazyGetStatesQuery}
        queryParams={{ country_id: US_COUNTRY_ID }}
        onChange={data => onSelectChange("state", data)}
        errorMessage={error.field === "state" ? error.message : ""}
      />
      <InputNew
        label="Service area (Optional)"
        placeholder="Enter service area"
        name="serviceArea"
        value={values.serviceArea}
        onChange={onInputChange}
        errorMessage={error.field === "serviceArea" ? error.message : ""}
      />
    </div>
  </>
)
